// extracted by mini-css-extract-plugin
export default {"homepage__section":"style_homepage__section__Z7WKR","homepage__texts":"style_homepage__texts__LRtdo"};